/* eslint-disable kf/const-naming-convention */

const HEADER_FILE_DATE = "file-fetched-on";
const KEY = "kfassets";

export const initCache = async (key) => {
  const cache = await caches.open(key);
  return cache;
};

export const getCache = async (url) => {
  let cache = await initCache(KEY);
  const response = await cache.match(url);
  if (response && isValid(response)) {
    return response;
  }

  let liveResponse = await fetch(url);

  let copyResponse = liveResponse.clone();
  let headers = new Headers(copyResponse.headers);
  headers.append(HEADER_FILE_DATE, new Date().getTime());

  let body = await copyResponse.blob();

  cache.put(
    url,
    new Response(body, {
      status: copyResponse.status,
      statusText: copyResponse.statusText,
      headers: headers
    })
  );
  return liveResponse;
};

const isValid = (response) => {
  if (!response) return false;
  var fetched = response.headers.get(HEADER_FILE_DATE);
  if (
    fetched &&
    parseFloat(fetched) + 1000 * 60 * 60 * 2 > new Date().getTime()
  )
    return true;
  return false;
};

export const deleteExpiredCache = async () => {
  let cache = await initCache(KEY);
  let cacheKeys = await cache.keys();
  for (let cacheKey of cacheKeys) {
    const response = await cache.match(cacheKey);
    if (response && !isValid(response)) {
      cache.delete(cacheKey);
    }
  }
};

export const clearCache = () => {
  caches.delete(KEY);
};

export const clearCachedProfilePicture = () => {
  caches.delete("profile-pictures");
};
